/**
 * The filled fraction of an account's used-of-granted bar (allotted, purchased,
 * staff). One shared function so the three bars cannot drift: whole percent,
 * clamped to 100 — an overdrawn account (spend raced a sweep, or an adjustment
 * shrank the grant after usage) fills the bar rather than overflowing the
 * track. Zero when nothing was granted: the bar is hidden then, but the bound
 * figure must still be a number, never NaN from a 0/0.
 *
 * Inputs are optional because the staff fields are absent from older server
 * payloads; a missing figure reads as 0.
 */
export function accountPercent(used: number | undefined, granted: number | undefined): number {
    const total = granted || 0;
    if (total <= 0) return 0;
    return Math.min(100, Math.round(((used || 0) / total) * 100));
}
